import gql from 'graphql-tag';

import cardDetails from '../fragments/cardDetails';

const getCardQuery = gql`
  query getCardQuery($id: RecordID!) {
    card(id: $id) {
      ...cardDetails
    }
  }
  ${cardDetails}
`;

export default getCardQuery;
